import { listPublicJobOffers } from "../field-work-service";

/**
 * Offres de travaux champêtres ouvertes (agri-farming-operations-platform), sans JWT :
 * GET /public/job-offers?country=&q=&page=&size=. « q » : chaque mot doit figurer dans le
 * titre, le type de travail, la description ou l'entreprise.
 */
export const searchJobOffers = ({ q = "", country, page = 0, size }) =>
    listPublicJobOffers({ country, page, size, q: q.trim() || undefined });
